import { createSlice } from "@reduxjs/toolkit";
import httpService from "../../support/http/HttpServices";
import { handleError } from "../config/configurationSlice";
export const WebFormInitialState = () => ({
  orderID: "",
  orderDetails: {},
  loader: false,
  tenantDetails: {},
  validTenant: "",
  tenantLoader: false,
  errorMessage:"",
  userDetails: {},
  registrationStatus: false,
  registrationLoader: false,
});
export const WebFormSlice = createSlice({
  name: "webform",
  initialState: WebFormInitialState(),
  reducers: {
    updateOrderID: (state, action) => {
      state.orderID = action.payload;
    },
    updateOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    },
    toggleLoader: (state, action) => {
      state.loader = action.payload;
    },
    updateValidTenant: (state, action) => {
      state.validTenant = action.payload;
    },
    updateTenantDetails: (state, action) => {
      state.tenantDetails = action.payload;
    },
    toggleTenantLoader: (state, action) => {
      state.tenantLoader = action.payload;
    },
    updateUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    updateErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    updateRegistrationStatus: (state, action) => {
      state.registrationStatus = action.payload;
    },
    toggleRegistrationLoader: (state, action) => {
      state.registrationLoader = action.payload;
    },
  },
});
export const {
  updateOrderID,
  updateOrderDetails,
  toggleLoader,
  updateValidTenant,
  updateTenantDetails,
  toggleTenantLoader,
  updateUserDetails,
  updateErrorMessage,
  updateRegistrationStatus,
  toggleRegistrationLoader,
} = WebFormSlice.actions;

export const validateOrderDetails = (orderID) => async (dispatch, getState) => {
  dispatch(toggleLoader(true));
  const envConfig = getState().config.envConfig;
  let headers = {
    Authorization: getState().config.authToken,
    "HON-Org-Id": getState().config.orgID,
  };
  return httpService
    .customGet(
      `${envConfig.hostname}${envConfig.api.subscription}${envConfig.api.webform}/${envConfig.apiVersion}/order-id/${orderID}`,
      {},
      headers
    )
    .then((response) => {
      dispatch(updateOrderDetails(response?.data));
      dispatch(updateOrderID(orderID));
      dispatch(toggleLoader(false));
    })
    .catch((error) => {
      dispatch(handleError());
      dispatch(toggleLoader(false));
    });
};

export const registerUser = (data) => async (dispatch, getState) => {
  const envConfig = getState().config.envConfig;
  let headers = {
    Authorization: getState().config.authToken,
    "HON-Org-Id": getState().config.orgID,
  };
  return httpService
    .customPost(
      `${envConfig.hostname}${envConfig.api.subscription}${envConfig.api.webform}/${envConfig.apiVersion}/register`,
      data,
      {},
      headers
    )
    .then((response) => {
      dispatch(updateUserDetails(data));
      if (response?.status === 200) {
        dispatch(updateRegistrationStatus("Success"));
      } else {
        dispatch(updateRegistrationStatus("Error"));
      }
      dispatch(toggleRegistrationLoader(false));
    })
    .catch((error) => {
      dispatch(updateUserDetails(data));
      dispatch(updateRegistrationStatus("Error"));
      dispatch(toggleRegistrationLoader(false));
    });
};

export const validateTenantDetails =
  (tenantID) => async (dispatch, getState) => {
    dispatch(toggleTenantLoader(true));
    dispatch(updateValidTenant(""));
    const envConfig = getState().config.envConfig;
    let headers = {
      Authorization: getState().config.authToken,
      "HON-Org-Id": getState().config.orgID,
    };
    return httpService
      .customGet(
        `${envConfig.hostname}${envConfig.api.subscription}${envConfig.api.opintelUsers}/${envConfig.apiVersion}/tenant-id/${tenantID}`,
        {},
        headers
      )
      .then((response) => {
        if (response?.status === 200) {
          const data = response?.data?.data;
          dispatch(updateTenantDetails(data));
          if (data?.id && data?.status === "Active")
            dispatch(updateValidTenant("Success"));
        } else {
          dispatch(updateValidTenant("Invalid"));
        }
        dispatch(toggleTenantLoader(false));
      })
      .catch((error) => {
        if (error?.response?.status === 400) {
          dispatch(updateValidTenant("Invalid"));
          dispatch(updateErrorMessage(error?.response?.data?.error?.errorDescription ? error?.response?.data?.error?.errorDescription : ""))
        } else {
          dispatch(
            updateValidTenant("Something went wrong, please try again later.")
          );
        }
        dispatch(toggleTenantLoader(false));
      });
  };

export const orderIDSelector = (state) => state.webform.orderID;
export const orderDetailsSelector = (state) => state.webform.orderDetails;
export const loaderSelector = (state) => state.webform.loader;
export const tenantDetailsSelector = (state) => state.webform.tenantDetails;
export const validTenantSelector = (state) => state.webform.validTenant;
export const errorMessageSelector = (state) => state.webform.errorMessage;
export const tenantLoaderSelector = (state) => state.webform.tenantLoader;
export const userDetailsSelector = (state) => state.webform.userDetails;
export const registrationStatusSelector = (state) =>
  state.webform.registrationStatus;
export const registrationLoaderSelector = (state) =>
  state.webform.registrationLoader;

export default WebFormSlice.reducer;
